module.exports = __webpack_public_path__ + "img/2.633fc41b.png";